<div class="container">
  <h1 class="mb-4" data-test-id="app-sales-report-e-header">{{salesReportTranslations.salesReportHeader}}</h1>

  <div class="row" [formGroup]="datepicker">
    <div class="col-md-3 col-lg-2">
      <h4>{{salesReportTranslations.dateRangeSubHeader}}</h4>
      <div class="date-range-container d-flex">
        <div [ngClass]="applyErrorStylingClass(fromDateHasError, 'mb-4')" class="from-date-container d-flex">
          <label aria-label="from-datepicker-label" class="control-label fw-bold mb-2">{{salesReportTranslations.fromDateLabel}}</label>
          <mat-form-field floatLabel="never" class="mb-2" data-test-id="app-sales-report-from-date-datepicker">
            <div class="input-styling d-flex">
              <input
                matInput
                [matDatepicker]="pickerFrom"
                [placeholder]="placeholderText()"
                (dateChange)="updateFromDate($event)"
                [formControl]="fromDateFormControl"
                formControlName="fromDateFormControl"
                [min]="minDateFrom"
                [max]="maxDateFrom"
                aria-label="from-datepicker-input"
                data-test-id="app-sales-report-e-from-date-datepicker-input"
                [class.is-invalid]="fromDateHasError">
            </div>
            @if (fromDateHasError) {
              <mat-error
              class="datepicker-invalid" id="fromDate-error" data-test-id="app-sales-report-from-date-datepicker-error-text" role="alert" aria-invalid="true">{{salesReportTranslations.fromDateErrorText}}</mat-error>
            }
            <mat-datepicker-toggle id="sales-report-calendar" data-test-id="app-sales-report-from-date-datepicker-toggle" matIconSuffix [for]="pickerFrom" [disableRipple]="true">
              <mat-icon matDatepickerToggleIcon class="allycon-calendar" data-test-id="app-sales-report-from-date-datepicker-icon" aria-hidden="true"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #pickerFrom id="sales-report-calendar" data-test-id="app-sales-report-from-date-datepicker-popout" [startAt]="fromStartDate"></mat-datepicker>
          </mat-form-field>
        </div>

        <div [ngClass]="applyErrorStylingClass(toDateHasError, 'mb-3')" class="to-date-container d-flex">
          <label aria-label="to-datepicker-label" class="control-label fw-bold mb-2">{{salesReportTranslations.toDateLabel}}</label>
          <mat-form-field floatLabel="never" data-test-id="app-sales-report-to-date-datepicker">
            <div class="input-styling d-flex">
              <input
                matInput
                [matDatepicker]="pickerTo"
                [placeholder]="placeholderText()"
                (dateChange)="updateToDate($event)"
                [formControl]="toDateFormControl"
                formControlName="toDateFormControl"
                [min]="minDateTo"
                [max]="maxDateTo"
                aria-label="to-datepicker-input"
                data-test-id="app-sales-report-to-date-datepicker-input"
                [class.is-invalid]="toDateHasError">
            </div>
            @if (toDateHasError) {
              <mat-error
              class="datepicker-invalid" id="toDate-error" data-test-id="app-sales-report-to-date-datepicker-error-text" role="alert" aria-invalid="true">{{salesReportTranslations.toDateErrorText}}</mat-error>
            }
            <mat-datepicker-toggle data-test-id="app-sales-report-to-date-datepicker-toggle" id="sales-report-calendar" matIconSuffix [for]="pickerTo" [disableRipple]="true">
              <mat-icon matDatepickerToggleIcon data-test-id="app-sales-report-to-date-datepicker-icon" class="allycon-calendar" aria-hidden="true"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #pickerTo data-test-id="app-sales-report-to-date-datepicker-popout" [startAt]="toStartDate"></mat-datepicker>
          </mat-form-field>
        </div>

      </div>
      <div [ngClass]="applyErrorStylingClass(toDateHasError, 'mt-3')" class="refresh-container">
        <p class="small-text">{{salesReportTranslations.dateRange31Days}}</p>
        <button class="btn btn-primary mb-3 refresh-btn" allytmln="Refresh" data-test-id="app-sales-report-e-refresh-button" (click)="refreshData()">{{salesReportTranslations.refresh}}</button>
      </div>
    </div>

    <div class="col-md-9 col-lg-10">
      <h4>{{dealershipName}} - {{tenantShortName}} {{salesReportTranslations.sales}}</h4>
      <div class="sales-container">
        @if (!dataLoading) {
          <table class="table table-borderless">
            <thead>
              <tr>
                <th scope="col">{{salesReportTranslations.nameTableHeader}}<hr class="divider"></th>
                <th scope="col" class="count-column">{{salesReportTranslations.vehiclesSoldTableHeader}}<hr class="divider"></th>
                <th scope="col" class="count-column">{{salesReportTranslations.dealerCountTableHeader}}<hr class="divider"></th>
              </tr>
            </thead>
            <tbody>
              @for (data of tableData; track data) {
                <tr>
                  <td>{{data.accountManagerName}}</td>
                  <td [ngClass]="data.isHighestSeller ? 'fw-bold': ''">{{data?.salesCount}}</td>
                  <td [ngClass]="data.hasMostBuyingDealers ? 'fw-bold': ''">{{data?.buyingDealersCount}}</td>
                </tr>
              }
              <tr>
                <td class="gray-text"><em>{{salesReportTranslations.unassignedTableCell}}</em><hr class="divider"></td>
                <td class="gray-text"><em>{{unassignedSalesObj?.salesCount || 0}}</em><hr class="divider"></td>
                <td class="gray-text"><em>{{unassignedSalesObj?.buyingDealersCount || 0}}</em><hr class="divider"></td>
              </tr>
              <tr class="fw-bold">
                <td>{{salesReportTranslations.totalTableCell}}</td>
                <td>{{totalSales}}</td>
                <td>{{totalBuyingDealers}}</td>
              </tr>
            </tbody>
          </table>
        }
        @if (dataLoading) {
          <div class="d-flex justify-content-center align-items-center mt-4 mb-3 spinner-container">
            <app-spinner></app-spinner>
          </div>
        }
      </div>
      <p class="small-text mt-3">{{salesReportTranslations.reportGenerated}} {{date}} &commat; {{time}}</p>
    </div>
  </div>
